import { Box, Button, Text, useConfirmationDialog } from '@factorialco/deprecated-design-system'
import { CompetencyCellItemFragment, UnassignCompetencyDocument } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  roleId: number
  competency: CompetencyCellItemFragment
  onUnassign: () => void
}

export const CompetencyCellItem = ({ roleId, competency, onUnassign }: Props) => {
  const { navigation } = useNavigation()
  const { openDialog } = useConfirmationDialog()
  const [unassignCompetencyFromRole] = useMutation(UnassignCompetencyDocument, {
    extractorFn: (data) => data.jobCatalogMutations.unassignCompetencyJobcatalogRole,
  })

  const onUnassignConfirmed = async () => {
    track(trackingEvents.jobCatalog.jobRolePageCompetencyUnassignSubmit)
    const result = await unassignCompetencyFromRole({
      variables: { id: roleId, competencyId: competency.id },
    })
    const handled = handleResult(result, () => {})

    if (handled.success) {
      onUnassign()
    }
  }

  return (
    <Box
      borderRadius={{ all: 'abs008' }}
      border={{ all: { color: 'grey400', style: 'solid', width: 's2' } }}
      padding="s16"
      height="s200"
      gap="s16"
    >
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Text.Normal weight="medium">{competency.name}</Text.Normal>
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative
              type="secondary"
              aria-label={i18n.t('job_catalog.competencies.competencies_table_competency_options', {
                competencyName: competency.name,
              })}
              iconName="ellipsis"
            />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="center">
            <PopoverMenu.RouterOption
              title={i18n.t('job_catalog.competencies.edit_competency')}
              to={{
                pathname: navigation.competencies.competencyId.settings.fullPath({
                  competencyId: competency.id,
                }),
              }}
              onClick={() => track(trackingEvents.jobCatalog.jobRolePageCompetencyEdit)}
            />
            {!competency.everyone && (
              <PopoverMenu.TouchableOption
                title={i18n.t('job_catalog.competencies.unassign_from_role')}
                onClick={() => {
                  track(trackingEvents.jobCatalog.jobRolePageCompetencyUnassign)

                  openDialog({
                    title: i18n.t('job_catalog.competencies.unassign_competency_title'),
                    description: i18n.t('job_catalog.competencies.unassign_competency_description'),
                    onConfirm: onUnassignConfirmed,
                  })
                }}
                danger
              />
            )}
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>
      <Text.Normal lineClamp={5}>{competency.description}</Text.Normal>
    </Box>
  )
}
